import { useMemo } from 'react';
import type { ComponentWithValues } from 'common/stack/ComponentWithValuesDocuments';
import { listComponentEnvironmentVariables } from 'common/stack/stackEnvUtils';
import { ComponentConnectionString } from './ComponentConnectionString';

interface ComponentConnectionStringsProps {
  component: ComponentWithValues | null | undefined;
}

export const ComponentConnectionStrings = ({ component, ...other }: ComponentConnectionStringsProps) => {
  if (!component) return null;

  const variables = useMemo(
    () =>
      listComponentEnvironmentVariables({
        component,
        includeBuiltInVariables: true,
        includeUserDefinedVariables: true,
      }).reduce((variables, env) => ({ ...variables, [env.identifier]: env.value }), {} as { [key: string]: string | number | boolean }),
    [component]
  );

  if (!component?.config?.connectionStrings?.length) return null;

  return (
    <section {...other}>
      {component?.config?.connectionStrings.map((connectionString) => (
        <ComponentConnectionString connectionString={connectionString} variables={variables} />
      ))}
    </section>
  );
};
